import { useMutation } from "@tanstack/react-query"
import axios from "axios"
import { BillingContactSchema } from "schema"
import { z } from "zod"

type Props = z.input<typeof BillingContactSchema>

export function useContactMutation() {
  return useMutation({
    mutationFn: async (data: Props) => axios.post("/billing/contact", data),
  })
}
